import { render } from "./Stats.vue?vue&type=template&id=21df7384&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=21df7384&scoped=true&lang=css"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21df7384"]])

export default __exports__